import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMask from 'v-mask'
import { getConfig, appConfig } from '@/utils/config-api'
import { userStore } from '@/utils/userstore'
import { checkAuthentication, reAuthenticate } from '@/utils/auth-api'
import { abilitiesPlugin, Can } from '@casl/vue'
import { setAbilities, ability } from '@/utils/ability'

import MaterialKit from './plugins/material-kit'

Vue.config.productionTip = false

Vue.use(VueMask)
Vue.use(MaterialKit)

getConfig().then(result => {
  appConfig.clientsPortalURL = result.clientsPortalURL
  appConfig.adminPortalURL = result.adminPortalURL
  appConfig.clientId = result.clientId
  appConfig.authorizeURL = result.authorizeURL
  appConfig.logoutURL = result.logoutURL
  appConfig.redirectURL = result.redirectURL

  router.beforeEach((to, from, next) => {
      console.log('beforeEach start')
      if (to) {
        if (to.meta) {
          if (to.meta.requiredAuth) {
            checkAuthentication(router, to).then(response => {
              console.log('beforeEach checkAuthentication response:')
              console.log(response)
              if (response) {
                // refreshAuthenticated()
                console.log('beforeEach:' + userStore.state.userDomain)
                switch(userStore.state.userDomain) {
                  case 'WORKER':
                    console.log('beforeEach worker user domain - goto reguested page:')
                    console.log(to)
                    next()
                    return
                    break
                  case 'MONTAGE':
                    if (!userStore.state.phone && to.name !== 'AddPhone' && to.name !== 'PhoneConfirm') {
                      console.log('beforeEach montage has no phone')
                      next({ name: 'AddPhone' })
                      return
                    }
                    break
                  case 'CLIENT':
                    if (!userStore.state.phone && to.name !== 'AddPhone' && to.name !== 'PhoneConfirm') {
                      console.log('beforeEach client has no phone')
                      next({ name: 'AddPhone' })
                      return
                    }
                    break
                }
                console.log('beforeEach no user domain action - goto requested page')
                next()
              } else {
                console.log('beforeEach checkAuthentication no response - goto main page')
                next()
              }
            }).catch(error => {
              console.log('beforeEach checkAuthentication error - reAuthenticate')
              reAuthenticate(router, to, error)
            })
          } else {
            console.log('beforeEach no required auth - goto requested page')
            next()
          }
        } else {
          console.log('beforeEach no meta - goto requested page')
          next()
        }
      } else {
        console.log('beforeEach no to - goto requested page')
        next()
      }
    })
  
  new Vue({
    router,
    render: h => h(App),
    created: function () {
      setAbilities(null)
    },
  }).$mount('#app')
    
}).catch(error => {
  alert('Ошибка инициализации приложения' + error)
})
